import PasswordValidator from "password-validator";

import { GET_USER } from "actions/ActionTypes";

export const email_regex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

export const getUserPayload = (token) => ({
  endpoint: "/api/user/v3/profile",
  type: GET_USER,
  item: "user",
  token,
});

export const validatePersonalInformation = (user) => {
  if (typeof user.last_name !== "string")
    return { isValid: false, error: "errorValidationLastname" };
  if (typeof user.first_name !== "string")
    return { isValid: false, error: "errorValidationFirsname" };
  if (typeof user.email !== "string" || user.email.match(email_regex) === null)
    return { isValid: false, error: "errorValidationEmail" };

  return { isValid: true, error: "" };
};

export const validatePassword = (password) => {
  if (
    typeof password.oldPassword !== "string" ||
    password.oldPassword.length <= 0
  )
    return { isValid: false, error: "errorValidationOldPassword" };
  if (
    typeof password.newPassword !== "string" ||
    password.newPassword.length <= 0
  )
    return { isValid: false, error: "errorValidationNewPassword" };

  return { isValid: true, error: "" };
};

export const getPasswordComplexity = (password) => {
  let complexity = 0;

  if (password.length > 8) complexity += 1;
  if (password.match(/.*[A-Z].*/)) complexity += 1;
  if (password.match(/.*[0-9].*/)) complexity += 1;
  if (password.match(/.*[$&+,:;=?@#|'<>.^*()%!-].*/)) complexity += 1;

  return complexity;
};

/*
  Password validation function.
  Possible rules: ['min8', 'lowercase', 'uppercase', 'digits']
*/
export const validatePasswordRules = (password, rules) => {
  let schema = new PasswordValidator();
  schema = schema.has().not().spaces();
  rules.forEach((rule) => {
    switch (rule) {
      case "min8": {
        schema = schema.is().min(8);
        break;
      }
      case "lowercase": {
        schema = schema.has().lowercase();
        break;
      }
      case "uppercase": {
        schema = schema.has().uppercase();
        break;
      }
      case "digits": {
        schema = schema.has().digits();
        break;
      }
    }
  });
  return schema.validate(password);
};

export const getComplexityClassName = (password, complexity) => {
  if (password.length <= 0) return "";
  switch (complexity) {
    case 0:
      return "password-weak";
    case 1:
      return "password-weak";
    case 2:
      return "password-okay";
    case 3:
      return "password-good";
    case 4:
      return "password-strong";
    default:
      return "password-weak";
  }
};

export const hasRole = (roles, role) => {
  if (roles && roles.indexOf(role) >= 0) return true;

  return false;
};
